export default __webpack_public_path__ + "assets/chevron-down-component.85c6a67e.svg";